import Page from '../../../Components/Page'
import { HEADBOX_ROOT_SERVICE } from '../../../Constants'
import { PartialBrief } from '../../../Types/Brief'
import getGuestEventsURL from '../getGuestEventsURL/getGuestEventsURL'
import { EnvelopeIconSVG, HeartIconSVG, TickIconSVG } from './SuccessPageIcons'

const MAX_ENQUIRY_RESPONSES = 15

const SuccessLink = ({ secret }: { secret: string | null }): JSX.Element =>
  secret ? (
    <a
      className='hb-button primary-button'
      href={getGuestEventsURL({ showSuccess: false }).toString()}>
      View your enquiry
    </a>
  ) : (
    <a className='home-page-link' href={HEADBOX_ROOT_SERVICE}>
      Return to homepage
    </a>
  )

const SuccessHeader = ({ guestEmail }: { guestEmail?: string }): JSX.Element => (
  <header className='success-header'>
    <div className='success-header-content'>
      <h1>
        <span className='visually-hidden'>All done!</span>
        Enquiry submitted. Nice.
      </h1>
      <p>
        We’ve sent a confirmation to{' '}
        <span className={guestEmail ? 'email' : ''}>{guestEmail ?? 'your email address.'}</span>
      </p>
    </div>
  </header>
)

interface LeadFeedSuccessPageProps {
  directEnquiry: boolean
  directEnquiryVenueName: string | null
  brief: PartialBrief
}

const LeadFeedSuccessPage = ({
  directEnquiry,
  directEnquiryVenueName,
  brief,
}: LeadFeedSuccessPageProps) => (
  <Page
    metaTitle='All done! - HeadBox'
    className='success-page fade-in'
    header={<SuccessHeader guestEmail={brief?.guest?.email} />}>
    <div className='success-card'>
      <h2>What happens next?</h2>
      <section className='card-section'>
        <h3 className='card-section-header'>
          <span className='icon-wrap'>
            <TickIconSVG className='card-section-icon' aria-hidden='true' />
            Sit back and relax
          </span>
        </h3>
        <p className='card-text'>
          We’ll now share your enquiry with{' '}
          {directEnquiry && !!directEnquiryVenueName
            ? `${directEnquiryVenueName} as well as `
            : directEnquiry
            ? 'your selected venue as well as '
            : ''}
          a suitable selection of our fantastic HeadBox venues.
        </p>
      </section>
      <section className='card-section'>
        <h3 className='card-section-header'>
          <span className='icon-wrap'>
            <EnvelopeIconSVG className='card-section-icon' aria-hidden='true' />
            Get messages from up to {MAX_ENQUIRY_RESPONSES} venues
          </span>
        </h3>
        <p className='card-text'>
          We’ll email you once messages start coming in from available venues.
        </p>
      </section>
      <section className='card-section'>
        <h3 className='card-section-header'>
          <span className='icon-wrap'>
            <HeartIconSVG className='card-section-icon' aria-hidden='true' />
            Match with your favourites
          </span>
        </h3>
        <p className='card-text'>
          Review your options, match with venues and they’ll be in touch directly to discuss things
          further.
        </p>
      </section>
      <SuccessLink secret={null} />
    </div>
  </Page>
)

export default LeadFeedSuccessPage
